<template>
  <div>
    <sidebar-menu
      :menu="menu"
      :theme="theme"
      :width="width"
      @update:collapsed="onToggleCollapse"
      @item-click="onItemClick"
    />

    <div id="content" class="mx-7">
      <div :class="[collapsedd ? 'lg:pl-64' : 'lg:pl-0']">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { SidebarMenu } from "vue-sidebar-menu";
import "vue-sidebar-menu/dist/vue-sidebar-menu.css";

export default {
  name: "Dashboard",
  components: { SidebarMenu },
  props: {
    id: {
      type: String,
      default: "",
    },
    theme: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "300px",
    },
  },
  created: function () {
    this.$store.commit("Candidate/updateId", sessionStorage.getItem("id"));
  },
  data() {
    return {
      router: useRouter(),
      collapsedd: true,
      menu: [
        {
          header: "Employment Hub",
          title: "Main Navigation",
          hiddenOnCollapse: true,
        },
        {
          href: "/dashboard",
          title: "Overview",
          icon: "fa-solid fa-user",
        },
        {
          href: "/application",
          title: "Application",
          icon: "fa-solid fa-file",
        },
        {
          href: "/subscription",
          title: "Subscription",
          // badge: {
          //   text: "Coming soon",
          //   class: "vsm--badge_default",
          // },
          icon: "fa-solid fa-indian-rupee-sign",
        },
        {
          title: "Log-out",
          icon: "fa-solid fa-power-off",
        },
      ],
    };
  },
  methods: {
    onCollapse() {
      this.collapsedd = !this.collapsedd;
    },
    onItemClick(event, item) {
      if (item.title == "Log-out") {
        this.router.push({ name: "Home" });
        sessionStorage.removeItem("id");
        location.reload();
      }
    },
    onToggleCollapse(collapsed) {
      if (collapsed) {
        this.onCollapse();
      } else {
        this.onCollapse();
      }
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Fira+Sans:wght@500&display=swap");

.v-sidebar-menu {
  background-color: #0b25b7;
}

.v-sidebar-menu .vsm--header {
  color: rgb(255, 255, 255);
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  background-color: transparent;
}
.v-sidebar-menu .vsm--header {
  font-size: 19px;
  font-family: "Fira Sans", sans-serif;
  letter-spacing: 2px;
}
.v-sidebar-menu {
  position: fixed;
}
</style>
